import { UI, HStack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { ResponsesWithdrawAssetResponse } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';
import React from 'react';

import { FixedIncomeWithdrawAssetNormalized } from '../../../../../../store/redemptionSolicitation/types';
import { CardTitle } from '../../../../components/CardTitle';
import { HighlightedInfos } from '../../../../components/HighlightedInfos';
import { InfoItem } from '../../../../components/InfoItem';
import { ProductCard } from '../../../../components/ProductCard';

import { getFixedIncomeAcceptQuotationNotice } from './constants';

export interface AcceptQuotationStepProps {
  onAccept: () => void;
  asset: FixedIncomeWithdrawAssetNormalized;
  quote: ResponsesWithdrawAssetResponse;
}

export const AcceptQuotationStep: React.FC<AcceptQuotationStepProps> = ({
  onAccept,
  asset,
  quote,
}) => {
  return (
    <VStack space={Spacing['stack.xxxs']}>
      <ProductCard barColor="product.rf">
        <VStack space={Spacing['stack.xxxs']}>
          <UI.Notice {...getFixedIncomeAcceptQuotationNotice(quote.quotationValidityDate!)} />

          <CardTitle title={asset.productNameNormalized} />
          <InfoItem label="Taxa de recompra" value={quote.rateDescription || '--'} />
          <InfoItem label="Valor solicitado" value={Utils.Mask.Money(quote.grossValue)} />

          <HighlightedInfos
            infos={[
              { label: 'IR', value: Utils.Mask.Money(quote.irValue) },
              { label: 'IOF', value: Utils.Mask.Money(quote.iofValue) },
            ]}
          />

          <InfoItem label="Valor a receber" value={Utils.Mask.Money(quote.netValue)} />
        </VStack>
      </ProductCard>

      <HStack
        alignSelf="end"
        space={Spacing['inline.xxxs']}
        w={Utils.Responsive.DesktopPhone({ phone: 'full', desktop: 'auto' })}
        justifyContent={Utils.Responsive.DesktopPhone({
          phone: 'space-between',
          desktop: 'inherit',
        })}>
        <UI.Button
          onPress={onAccept}
          isDisabled={false}
          w={Utils.Responsive.DesktopPhone({ phone: '45%', desktop: 'auto' })}>
          Aceitar
        </UI.Button>
      </HStack>
    </VStack>
  );
};
